<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <FormAttribute
          :data="eventAttributeKey"
          :loading="isFormLoading"
          @submit="formAttributeSubmit"
          @cancel="$router.push({ name: 'page-attributes' })"
          @delete-attr="deleteAttribute"
          :isNew="!name"
          :language="language"
          @language-update="language = $event"
        />
      </v-col>
    </v-row>
    <ConfirmationDialog ref="confirmEventRemoving" confirmText="Удалить" />
  </v-container>
</template>

<script>
import FormAttribute from '@/pages/attribute/form'
import ConfirmationDialog from '@/components/confirmation-dialog'
import CreateAttribute from '@/services/gql/types/EventAttributeKey/mutations/createEventAttributeKey.gql'
import eventAttributeKey from '@/services/gql/types/EventAttributeKey/queries/eventAttributeKey.gql'
import DeleteAttribute from '@/services/gql/types/EventAttributeKey/mutations/deleteEventAttributeKey.gql'
import UpdateAttribute from '@/services/gql/types/EventAttributeKey/mutations/updateEventAttributeKey.gql'
import eventAttributeKeys from '@/services/gql/types/EventAttributeKeys/queries/eventAttributeKeys.gql'
import { contentLocales, contentLocalesValues } from '@/configs/locales'
import { getListWithNewMainLanguage, setTranslation } from '@/utils/locales'

export default {
  name: 'PageAttribute',
  props: {
    name: {
      type: String,
      default: null
    }
  },
  components: {
    FormAttribute,
    ConfirmationDialog
  },
  metaInfo () {
    return {
      title: this.name ? 'Редактировать атрибут' : 'Создать атрибут'
    }
  },
  data () {
    return {
      language: contentLocales[0].value,
      eventAttributeKey: {},
      eventAttributeKeys: {}
    }
  },
  computed: {
    isFormLoading () {
      return (
        this.$apollo.queries.eventAttributeKey.loading ||
        this.$async.createAttribute.$pending ||
        this.$async.updateAttribute.$pending ||
        this.$apollo.queries.eventAttributeKeys.loading
      )
    }
  },
  methods: {
    formAttributeSubmit (attr) {
      if (!this.name) {
        this.createAttribute(attr)
      } else {
        this.updateAttribute(attr)
      }
    },
    async deleteAttribute () {
      try {
        await this.$refs.confirmEventRemoving.open()
        await this.$async.deleteAttribute.$perform({ name: this.name })
        this.$successMsg('Атрибут удален')
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(e.graphQLErrors, `Ошибка при удалении атрибута ${this.name}`)
      } finally {
        await this.$router.push({ name: 'page-attributes' })
      }
    },
    async createAttribute (data) {
      if (this.eventAttributeKeys?.list.find(attribute => attribute.name === data.name)) {
        this.$successMsg('Имя атрибута должно быть уникальным!')
        return
      }
      try {
        delete data.translations
        await this.$async.createAttribute.$perform({ data })
        this.$successMsg('Атрибут создан')
        await this.$router.push({ name: 'page-attributes' })
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при создании атрибута')
      }
    },
    async updateAttribute (data) {
      try {
        setTranslation(data, this.language)
        await this.$async.updateAttribute.$perform({
          name: this.name,
          data
        }, { Language: getListWithNewMainLanguage(this.language, contentLocalesValues()) })
        this.$successMsg('Атрибут обновлен')
        this.$emit('updated')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при обновлении события')
      }
    }
  },
  apollo: {
    eventAttributeKey: {
      fetchPolicy: 'network-only',
      query: eventAttributeKey,
      skip () {
        return !this.name
      },
      variables () {
        return {
          where: {
            name: this.name
          }
        }
      },
      context () { return { headers: { Language: getListWithNewMainLanguage(this.language, contentLocalesValues()) } } },
      result (res) {
        if (res.data === undefined) {
          this.$handleApiError(res.error)
          this.$router.push({ name: 'page-attributes' })
        } else {
          this.attribute = res.data.eventAttributeKey
        }
      }
    },
    eventAttributeKeys: {
      fetchPolicy: 'network-only',
      query: eventAttributeKeys,
      pollInterval: 30000,
      variables: {
        where: {}
      }
    }
  },
  async: {
    createAttribute (variables) {
      return this.$apollo.mutate({
        mutation: CreateAttribute,
        variables
      })
    },
    deleteAttribute (variables) {
      return this.$apollo.mutate({
        mutation: DeleteAttribute,
        variables
      })
    },
    updateAttribute (variables, headers) {
      return this.$apollo.mutate({
        mutation: UpdateAttribute,
        variables,
        context: {
          headers
        }
      })
    }
  }
}
</script>
